import { apiClient, unwrap } from '@services/api';
import type { CheckoutSession, MySubscription, SubscriptionPlanInfo } from '@/types';

export const subscriptionService = {
  async getPlans(): Promise<SubscriptionPlanInfo[]> {
    const res = await apiClient.get<SubscriptionPlanInfo[]>('/restaurant/subscription/plans');
    return unwrap(res);
  },

  async getMySubscription(): Promise<MySubscription> {
    const res = await apiClient.get<MySubscription>('/restaurant/subscription/me');
    return unwrap(res);
  },

  async startCheckout(planId: string): Promise<CheckoutSession> {
    const res = await apiClient.post<CheckoutSession>('/restaurant/subscription/checkout', {
      planId,
    });
    return unwrap(res);
  },

  async cancel(): Promise<{ canceled: boolean; accessUntil?: string | null }> {
    const res = await apiClient.post<{ canceled: boolean; accessUntil?: string | null }>(
      '/restaurant/subscription/cancel',
    );
    return unwrap(res);
  },

  async retryPayment(): Promise<{ retried: boolean }> {
    const res = await apiClient.post<{ retried: boolean }>(
      '/restaurant/subscription/retry-payment',
    );
    return unwrap(res);
  },
};
